export default {"src":"/_next/static/media/phone.6a45fa94.svg","height":104,"width":94};